const cartDrawerElement = document.querySelector(".cart-drawer");
const cartDrawerOpeners = document.querySelectorAll(".js-open-cart");
const closeDrawerOpener = document.querySelector(".js-close-cart-drawer");
import bodyLock from "../utils/body-lock";
import { initDraggableSliders } from "./draggable-sliders";

class cartDrawer {
  constructor() {
    cartDrawer.handleClickDragScroll();
    cartDrawer.handleCartSummaryOffset();
    // Cart notes stuff
    cartDrawer.handleCartNotes();

    // check url for cart open parameter
    const url = new URL(window.location.href);

    closeDrawerOpener.addEventListener("click", () => {
      bodyLock.unlock();
    });

    if (url.searchParams.get("cart")) {
      this.openCartDrawer();
    }

    // Add event listeners for the open cart drawer and close cart drawer buttons.
    if (cartDrawerElement) {
      if (cartDrawerOpeners) {
        cartDrawerOpeners.forEach((element) =>
          element.addEventListener("click", this.openCartDrawer)
        );
      }

      if (closeDrawerOpener) {
        closeDrawerOpener.addEventListener("click", cartDrawer.closeCartDrawer);
      }

      // Add event listener for the cart drawer itself.
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          //if esc key was not pressed in combination with ctrl or alt or shift
          const isNotCombinedKey = !(
            event.ctrlKey ||
            event.altKey ||
            event.shiftKey
          );
          if (isNotCombinedKey) {
            cartDrawer.closeCartDrawer();
          }
        }
      });

      // Check for click outside Cart Drawer
      document.addEventListener("click", (event) => {
        const withinBoundaries = event
          .composedPath()
          .includes(cartDrawerElement);
        let clickedOpener = false;

        cartDrawerOpeners.forEach((element) => {
          if (event.composedPath().includes(element)) {
            clickedOpener = true;
          }
        });

        if (!withinBoundaries && !clickedOpener) {
          cartDrawer.closeCartDrawer();
        }
      });
    }
  }

  /**
   * Get current state of the cart drawer.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState() {
    if (cartDrawerElement.classList.contains("js-drawer-open")) {
      return {
        state: "open",
        isCartOpen: true,
      };
    } else {
      return {
        state: "closed",
        isCartOpen: false,
      };
    }
  }

  /**
   * Open cart drawer.
   */
  openCartDrawer() {
    const themeColorElement = document.querySelector(
      'meta[name="theme-color"]'
    );

    cartDrawerElement.classList.remove("initial-load");
    cartDrawerElement.classList.add("js-drawer-open");

    // Change meta theme color.
    themeColorElement.setAttribute("content", "#fff");

    // add body scroll lock.
    bodyLock.lock();

    // add class to body
    document.body.classList.add("cart-drawer-open");
  }

  /**
   * Close cart drawer.
   */
  static closeCartDrawer() {
    const themeColorElement = document.querySelector(
      'meta[name="theme-color"]'
    );
    const announcementBarElement = document.querySelector(".announcement-bar");
    const announcementBarHeight = announcementBarElement.offsetHeight;
    const offset = announcementBarHeight * 3;
    const themeColor = window.topBarColor;
    const scrollPosition = window.scrollY;
    cartDrawerElement.classList.remove("js-drawer-open");

    // Change meta theme color.
    if (scrollPosition > offset) {
      themeColorElement.setAttribute("content", "#F8F3ED");
    } else {
      themeColorElement.setAttribute("content", themeColor);
    }

    // remove body scroll lock.

    // Remove class to body
    document.body.classList.remove("cart-drawer-open");
    bodyLock.unlock();

    // bodyLock.unlock()
  }

  /**
   * Handle open cart drawer.
   */
  handleOpenCartDrawer() {
    const currentState = this.getCurrentState();

    if (currentState.isCartOpen) {
      cartDrawer.closeCartDrawer();
    } else {
      this.openCartDrawer();
    }
  }

  /**
   * Handel click and drag scrolling inside the cart drawer
   */

  static handleClickDragScroll = () => {
    // https://codepen.io/thenutz/pen/VwYeYEE
    // Rebuild it to support multiple sliders

    initDraggableSliders();
  };

  /**
   * Handle cart summary offset for scrolling inside the cart drawer
   * ?? Maybe also add to the cart-state.js
   */

  static handleCartSummaryOffset = () => {
    const cartSummary = document.querySelector("#cart-summary");
    const cartDrawerContent = document.querySelector(".cart-drawer__content");

    if (cartSummary && cartDrawerContent) {
      cartDrawerContent.style.paddingBottom =
        parseFloat(cartSummary.offsetHeight + 120) + "px";
    }
  };

  /**
   * Check sessionStorage and set cartNotes
   */
  static setCartNotes = () => {
    // Textareas
    const textareas = document.querySelectorAll("#gift-note, #request-note");
    if (textareas.length > 0) {
      textareas.forEach((textarea) => {
        if (sessionStorage.getItem(textarea.id)) {
          textarea.value = sessionStorage.getItem(textarea.id);
        }
      });
    }

    // Checkbox
    // Checkbox
    const checkbox = document.querySelector("#gift-wrapping-option");

    if (checkbox) {
      if (sessionStorage.getItem(checkbox.id) === "true") {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    }
  };

  /**
   * Save cart notes across page refreshes in the session storage
   */
  static handleCartNotes = () => {
    cartDrawer.setCartNotes();
    // Textareas
    const textAreas = document.querySelectorAll("#gift-note, #request-note");

    if (textAreas.length > 0) {
      textAreas.forEach((textArea) =>
        textArea.addEventListener("input", function () {
          sessionStorage.setItem(this.id, this.value);
        })
      );
    }

    // Checkbox
    const checkbox = document.querySelector("#gift-wrapping-option");

    if (checkbox) {
      checkbox.addEventListener("change", function () {
        sessionStorage.setItem(this.id, this.checked);
      });
    }
  };
}

export default new cartDrawer();
